/**
 * @file Manages the Reactjs Container and init methods.
 */

import './core/App.css'

import React from 'react'
import { Toaster } from 'react-hot-toast'
import Navigation from './navigation/Navigation'
import Initializers from './core/Initializers'
import ClientHeightObserver from './core/ClientHeightObserver'
import ErrorWrapper from './components/ErrorBoundary/ErrorFallback'
import { Parameters } from './contexts/parameters'
import { LearningProvider } from './contexts/learning'
import { useLocation } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './styles/RiseupLayout.scss'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import PublicNavigation, { publicRoutes } from './navigation/PublicNavigation'

// Create a client
const queryClient = new QueryClient()

// Public app : not protected by the authentication (no accesstoken)
function PublicApp() {
  return (
    <ErrorWrapper>
      <ClientHeightObserver>
        <PublicNavigation />
      </ClientHeightObserver>
    </ErrorWrapper>
  )
}

// Private app : protected by the authentication (accesstoken)
function PrivateApp() {
  const location = useLocation()
  const isShow = location.pathname.split('/').includes('learning_programs')

  return (
    <ErrorWrapper>
      <ClientHeightObserver>
        <Parameters>
          <LearningProvider>
            <Initializers>
              <QueryClientProvider client={queryClient}>
                <div className={`bodyWrapper ${isShow ? 'lightBg' : ''}`}>
                  <div className={'App domScroll'}>
                    <Navigation />
                    <Toaster />
                  </div>
                </div>
                <ReactQueryDevtools
                  initialIsOpen={false}
                  panelProps={{ style: { height: 400, width: 1000 } }}
                  position='bottom-left'
                />
              </QueryClientProvider>
            </Initializers>
          </LearningProvider>
        </Parameters>
      </ClientHeightObserver>
    </ErrorWrapper>
  )
}

function App() {
  const location = useLocation()

  if (publicRoutes.includes(location.pathname)) {
    return <PublicApp />
  } else {
    return <PrivateApp />
  }
}

export default App
